import { useEffect, useRef, type RefObject } from "react"

function scrollListToBottom(listRef: RefObject<HTMLDivElement | null>) {
  requestAnimationFrame(() => {
    setTimeout(() => {
      const el = listRef.current
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    }, 0)
  })
}

/**
 * Прокрутка списка вниз при новом сообщении пользователя или ассистента.
 */
export function useChatScrollToBottomOnAssistant(
  open: boolean,
  messages: { role: string; message_id?: string }[],
  listRef: RefObject<HTMLDivElement | null>
) {
  const prevMessagesCountRef = useRef<number>(0)
  const prevLastAssistantMessageIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (!open || messages.length === 0) return

    const last = messages[messages.length - 1]
    const lastAssistantMessage = [...messages].reverse().find((m) => m.role === "assistant")
    const lastAssistantMessageId = lastAssistantMessage?.message_id || null

    const lengthIncreased = messages.length > prevMessagesCountRef.current

    const hasNewAssistantMessage =
      lengthIncreased &&
      lastAssistantMessageId !== null &&
      lastAssistantMessageId !== prevLastAssistantMessageIdRef.current

    const hasNewUserMessage = lengthIncreased && last?.role === "user"

    if (hasNewAssistantMessage || hasNewUserMessage) {
      scrollListToBottom(listRef)
    }

    prevMessagesCountRef.current = messages.length
    prevLastAssistantMessageIdRef.current = lastAssistantMessageId
  }, [messages, open, listRef])
}
